var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      ref: "menu",
      attrs: {
        "close-on-content-click": false,
        transition: "scale-transition",
        "offset-y": "",
        "full-width": "",
        "nudge-right": 40,
        "max-width": "290px",
        "min-width": "290px",
      },
      model: {
        value: _vm.menu,
        callback: function ($$v) {
          _vm.menu = $$v
        },
        expression: "menu",
      },
    },
    [
      _c(
        "v-text-field",
        _vm._b(
          {
            attrs: { slot: "activator", mask: _vm.dateMask, rules: _vm.rules },
            on: {
              blur: function ($event) {
                return _vm.parseDate(_vm.fieldValue)
              },
            },
            slot: "activator",
            model: {
              value: _vm.fieldValue,
              callback: function ($$v) {
                _vm.fieldValue = $$v
              },
              expression: "fieldValue",
            },
          },
          "v-text-field",
          _vm.$attrs,
          false
        )
      ),
      _vm._v(" "),
      _c("v-date-picker", {
        attrs: { "no-title": "", scrollable: "", actions: "" },
        on: {
          input: function ($event) {
            _vm.menu = false
          },
        },
        model: {
          value: _vm.dateValue,
          callback: function ($$v) {
            _vm.dateValue = $$v
          },
          expression: "dateValue",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }